import { render, staticRenderFns } from "./modifyAccountDialog.vue?vue&type=template&id=37f50f7e"
import script from "./modifyAccountDialog.vue?vue&type=script&lang=js"
export * from "./modifyAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports